import React, {useEffect, useRef, useState} from 'react';
import cl from "./FormDatePeriodInput.module.css";
import {TextField} from "@mui/material";
import FormControlCaption from "./FormControlCaption";

const FormDatePeriodInput = ({
                                   label,
                                   initFromValue,
                                   initTillValue,
                                   controlRef,
                                   placeholder,
                                   validateDateFunc, // проверка отдельно каждой даты
                                   validateDatesFunc, // проверка пары дат (по отношению друг к другу)
                                   tipText,
                                   readOnly,
                               }) => {

    const inputFromRef = useRef(null);
    const inputTillRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("")

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                getFromDate: getFromText,
                getTillDate: getTillText,
                validateNotEmpty: validateNotEmpty,
                validateDates: validateDates,
                setErrorMessage: setErrorMessage,
            };
        }
    })

    function getFromText() {
        return inputFromRef.current.value.trim();
    }

    function getTillText() {
        return inputTillRef.current.value.trim();
    }

    function validateNotEmpty(errorMessage) {
        if (getFromText() || getTillText())
            return true;
        setErrorMessage(errorMessage);
        return false;
    }

    function validateDates(errorMessage) {
        if (validateDateFunc && (!validateDateFunc(getFromText()) || !validateDateFunc(getTillText()))) {
            setErrorMessage(errorMessage);
            return false;
        }

        if (validateDatesFunc && (!validateDatesFunc(getFromText(), getTillText()))) {
            setErrorMessage(errorMessage);
            return false;
        }

        return true;
    }

    function renderTextField(inputRef, initValue, error, errorMessage, placeholder) {
        return <TextField
            type="text"
            variant="outlined"
            hiddenLabel
            inputRef={inputRef}
            defaultValue={initValue}
            placeholder={placeholder}
            error={error}
            helperText={errorMessage}
            sx={{width: `min(130px, 40%)`}}
            slotProps={{
                htmlInput: {
                    readOnly: readOnly,
                    sx: {backgroundColor: readOnly ? "#ffff0018" : "white", borderRadius: "4px"}
                },
                formHelperText: {
                    sx: {width: "max-content", maxWidth: "350px"}
                },
            }}
            onChange={() => {
                if (error)
                    setErrorMessage("")
            }}
        />
    }

    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <div className={cl.row}>
                {renderTextField(inputFromRef, initFromValue, errorMessage !== "", errorMessage, placeholder)}
                <span style={{marginTop: "18px"}}>—</span>
                {renderTextField(inputTillRef, initTillValue, errorMessage !== "", "", placeholder)}
            </div>
        </div>
    );
};

export default FormDatePeriodInput;